import React from 'react'
import { Link } from 'react-router-dom'
import ContentUpComingItem from './ContentUpComingItem';
import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../assets/css/news.css';
import { useIntl } from 'react-intl'; // ✅ Thêm useIntl

export default function ContentUpComing({ infoRelated, tittle = 'Highlights' }) {
    const intl = useIntl();
    const pathSplit = window.location.pathname.split('/')
    const lang = pathSplit[1]
    if (infoRelated === undefined) {
        return <></>
    }
    return (
        <div className="unicamp-event-box unicamp-box">
            <div className="box-header">
                <h4 className="box-title">
                    {intl.formatMessage({ id: tittle })}
                </h4>
                <div className="tm-button-wrapper">
                    <Link className="button-content-wrapper" to={lang === 'vi' ? '/vi/news/all' : '/news/all'}>
                        <span className="button-text">
                            {intl.formatMessage({ id: 'View All' })}
                        </span>
                    </Link>
                </div>
            </div>
            <div className="box-body">
                {
                    infoRelated && infoRelated.length > 0 ? (
                        infoRelated.map((item, index) => {
                            return (
                                <ContentUpComingItem info={item} key={index} ind={index} lang={lang}></ContentUpComingItem>
                            )
                        })
                    ) : (
                        <div className="p-3 text-center" style={{fontSize: '14px', color: '#666'}}>
                            {intl.formatMessage({ id: 'NoEventsFound' })}
                        </div>
                    )
                }
            </div>
        </div>
    )
}
